/* globals angular */

var ngModule = angular.module('trends');

ngModule.directive('regionalContext', ['Api', 'Restangular', 'Monitor',
    function (Api, Restangular, Monitor) {
        return {
            restrict: 'A',
            scope: {trend: '@'},
            templateUrl: null,
            link: function (scope) {
                var loader = new Monitor();
                scope.selections = {};
                scope.contents = [
                    {'title': 'What we\'ve seen', 'key': 'whatweveseen'},
                    {'title': 'What it means', 'key': 'body'},
                    {'title': 'What you should do', 'key': 'whatyoushoulddo'}
                ];
                // Load the HVTs for which this trend has WIIFs
                Api.cachedRequest(Restangular.one('ma_meta', scope.trend),
                'get', {hvt_type: 'region'}).then(function (meta) {
                    scope.regions = [];
                    var regions = meta.groups.region;
                    if(regions !== undefined) {
                        for (var i = 0; i < regions.length; i++) {
                            if (regions[i].description !== 'Other') {
                                scope.regions.push(regions[i]);
                            }
                        }
                    }
                    var visibility = false;
                    if (scope.regions.length !== 0) {
                        scope.selections.hvt_pk = scope.regions[0].pk;
                        var visibility = true;
                    }
                    scope.$emit('element-visibility', 'regional-wiif', visibility);
                });

                /* returns true if a load is occuring or before the initial load */
                scope.isResolved = function() {
                    return loader.resolved;
                };

                /* Determine if a load is in progress. */
                scope.isBusy = function() {
                    return loader.isBusy();
                };

                scope.$watch('selections.hvt_pk', function () {
                    if(scope.regions) {
                        for (var i = 0; i < scope.regions.length; i++) {
                            if (scope.selections.hvt_pk === scope.regions[i].pk) {
                                var promise = Api.cachedRequest(Restangular.all('wiif'), 'getList',
                                    {trend: scope.trend, hvt: scope.regions[i].hvt_id}).then(function(wiif) {
                                        scope.selections.wiif = wiif[0];
                                        scope.selections.content_index = 0;
                                    });
                                loader.watch(promise);
                            }
                        }
                    }
                });

                scope.displayed_content = function() {
                    var content;
                    if(scope.selections.wiif) {
                        for (var i = 0; i < scope.regions.length; i++){
                            if (scope.regions[i].pk === scope.selections.hvt_pk){
                                scope.selected_region = scope.regions[i].hvt_id;
                            }
                        }
                        scope.selected_context = scope.contents[scope.selections.content_index].key;
                        content = scope.selections.wiif[scope.contents[scope.selections.content_index].key];
                    }
                    return content || 'An error has occured.';
                };
            }
        };
}]);
